import { Icon, Spinner, Tab, Tabs } from "@blueprintjs/core"
import CustomButton from "components/Atoms/CustomButton"
import CustomDialog from "components/Atoms/CustomDialog"
import NoResults from "components/Organisms/NoResults"
import dayjs from "dayjs"
import { usePeriodicTaskDetailLazyQuery } from "generated/graphql"
import React, { useEffect } from "react"
import classNames from "utils/classNames"
import { downloadStringAsFile } from "utils/file.utils"
type TaskLogsProps = {
  taskId?: string
  isOpen?: boolean
  onClose?: any
  logs?: any[]
  title?: string
}

const TaskLogs = ({
  taskId,
  isOpen,
  onClose,
  logs: providedLogs,
  title: providedTitle,
}: TaskLogsProps) => {
  const [getDetails, { data, loading, error }] =
    usePeriodicTaskDetailLazyQuery()
  useEffect(() => {
    if (parseInt(taskId) && !providedLogs) {
      getDetails({ variables: { id: taskId } })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [taskId, providedLogs])

  const task = data?.periodicTaskDetail
  const logs = providedLogs || task?.logs

  return (
    <CustomDialog
      className="min-w-[50vw] max-h-full w-fit"
      icon="info-sign"
      light
      title={providedTitle || `${task?.task || "Task"} | Logs`}
      isOpen={isOpen}
      onClose={onClose}
    >
      {loading ? (
        <Spinner />
      ) : !logs?.length ? (
        <NoResults
          title={error?.message || "No Logs found for this periodic task"}
          icon="search"
        />
      ) : (
        <Tabs defaultSelectedTabId={logs[0].id} vertical>
          {logs.map(log => {
            // We do this to prettify the json string sent by the server.
            const requestData = JSON.stringify(
              JSON.parse(log.requestData),
              null,
              2
            )
            const responseData = JSON.stringify(
              JSON.parse(log.responseData),
              null,
              2
            )

            const statusIcon = (
              <Icon
                className={classNames(
                  "mr-2",
                  log.isOk ? "text-green" : "text-red"
                )}
                icon={log.isOk ? "endorsed" : "cross"}
              />
            )
            return (
              <Tab
                key={log.id}
                // className={log.isOk ? styles.successTab : styles.errorTab}
                id={log.id}
                title={
                  <span>
                    {statusIcon}
                    <span className="ml-1">
                      {dayjs(log.createdAt).format("Do MMM YY hh:mm:ss a")}
                    </span>
                  </span>
                }
                panelClassName="w-full"
                panel={
                  <div>
                    <div>
                      <h6 className="flex items-center justify-between">
                        <span>
                          {statusIcon}
                          {log.isOk ? "Success" : "Error"}
                        </span>
                        <span>Response code - {log.responseCode}</span>
                      </h6>
                    </div>
                    <Tabs animate={false} defaultSelectedTabId={`request`}>
                      <Tab
                        id={`request`}
                        title="Request"
                        panelClassName="w-fit"
                        panel={
                          <div>
                            <pre className="bg-gray-50 p-2 rounded-sm">
                              {requestData}
                            </pre>
                            <CustomButton
                              onClick={() =>
                                downloadStringAsFile(
                                  requestData,
                                  `${providedTitle || task?.task || "Task"}-${
                                    log.id
                                  }-request.json`
                                )
                              }
                              className="mt-2"
                              dark
                              icon="download"
                              text={"Download"}
                            />
                          </div>
                        }
                      />
                      <Tab
                        id={`response`}
                        title="Response"
                        panelClassName="w-fit"
                        panel={
                          <div>
                            <pre className="bg-gray-50 p-2 rounded-sm">
                              {responseData}
                            </pre>
                            <CustomButton
                              onClick={() =>
                                downloadStringAsFile(
                                  responseData,
                                  `${providedTitle || task?.task || "Task"}-${
                                    log.id
                                  }-response.json`
                                )
                              }
                              className="mt-2"
                              dark
                              icon="download"
                              text={"Download"}
                            />
                          </div>
                        }
                      />
                    </Tabs>
                  </div>
                }
              />
            )
          })}
        </Tabs>
      )}
    </CustomDialog>
  )
}

export default TaskLogs
